// IoT 模擬器（模擬門鈴等；docs/iot-sim/03-sd.md D4）的加入流程 —— 主人端，對齊 Android PhoneCamJoin.kt(simulator=true)
// 與 iOS PhoneCamJoinView(simulator: true)：
//   POST /v3/devices/binding {kind:"phone_cam"} → 短碼 → 模擬器 App 輸入短碼送申請
//   → 輪詢 GET /v3/devices/binding/{id} 拿 activation_id → GET 申請（比對碼）→ 主人核准 / 拒絕
//   → 等模擬器 bind（binding → bound）。
// 網頁沒有 QR 產生器，只給 8 碼短碼（模擬器 App 有「改輸入 8 碼短碼」）。
import { ApiError, apiFetch } from '../../lib/api';

/** 409：每個帳號同一種模擬裝置最多 6 台 */
export const SIM_LIMIT_CODE = 'sim_limit';
export const SIM_DOORBELL_KIND = 'sim-doorbell';

export interface SimBinding {
  binding_id: string;
  /** 秒 */
  expires_at: number;
  short_code: string;
  join_url?: string;
}

export interface SimBindingStatus {
  status: string;
  device_id?: string;
  activation_id?: string;
}

export interface SimActivation {
  activation_id: string;
  /** claimed → awaiting_confirm → approved → issued → bound；或 rejected / expired */
  state: string;
  binding_id?: string;
  match_code?: string;
  model_name?: string;
  device_id?: string;
  kind?: string;
}

const enc = encodeURIComponent;

export async function createSimBinding(): Promise<SimBinding> {
  return (await apiFetch<SimBinding>('/v3/devices/binding', { method: 'POST', body: { kind: 'phone_cam' } })).data;
}

export async function simBindingStatus(bindingId: string): Promise<SimBindingStatus> {
  return (await apiFetch<SimBindingStatus>(`/v3/devices/binding/${enc(bindingId)}`)).data;
}

export async function cancelSimBinding(bindingId: string): Promise<void> {
  await apiFetch(`/v3/devices/binding/${enc(bindingId)}`, { method: 'DELETE' });
}

export async function getSimActivation(activationId: string): Promise<SimActivation> {
  return (await apiFetch<SimActivation>(`/v3/soft-devices/activations/${enc(activationId)}`)).data;
}

export async function approveSimActivation(activationId: string): Promise<SimActivation> {
  return (await apiFetch<SimActivation>(`/v3/soft-devices/activations/${enc(activationId)}/approve`, { method: 'POST', body: {} })).data;
}

export async function rejectSimActivation(activationId: string): Promise<void> {
  await apiFetch(`/v3/soft-devices/activations/${enc(activationId)}/reject`, { method: 'POST', body: {} });
}

/** 短碼顯示成 4 碼一組（ABCD EFGH）。 */
export function formatShortCode(code: string): string {
  return (code.match(/.{1,4}/g) ?? []).join(' ');
}

/** 錯誤 → i18n key（sim_limit 給白話說明；過期 / 找不到 → 過期）。 */
export function simIotErrorKey(e: unknown): string {
  if (e instanceof ApiError) {
    if (e.code === SIM_LIMIT_CODE) return 'simiot.errLimit';
    if (e.code === 'bad_state' || e.status === 404) return 'simiot.expired';
  }
  return 'simiot.errGeneric';
}
